import { PortableText } from '@portabletext/react';
import { PortableTextBlock } from '@portabletext/types';

interface SectionHeaderProps {
  title?: string;
  subtitle?: string;
  description?: PortableTextBlock[];
  className?: string;
}

export function SectionHeader({
  title,
  subtitle,
  description,
  className = 'mb-8 md:mb-10 text-center',
}: SectionHeaderProps) {
  if (!title && !subtitle && !description) return null;

  return (
    <div className={className}>
      {title && (
        <h2 className="font-medium mb-3 text-section-title leading-section-title">{title}</h2>
      )}
      {subtitle && (
        <p className="text-muted-foreground text-section-subtitle leading-section-subtitle">
          {subtitle}
        </p>
      )}
      {description && (
        <div className="prose prose-lg max-w-3xl mx-auto mt-4 text-left text-muted-foreground">
          <PortableText value={description} />
        </div>
      )}
    </div>
  );
}
